import {connect} from 'react-redux';
import React, {Component} from 'react';
import Checkpoint from 'catalog/components/Checkpoint';
import {Card, CardBody} from 'reactstrap'
import Loading from 'apa/components/Loading'
import NewCheckpoint from 'catalog/components/NewCheckpoint';
import DroppableContext from 'catalog/containers/DroppableContext'
import DnDContext from 'catalog/containers/DnDContext';

@connect(
    state => ({
        checkpointList: state.categories.checkpointList,
        checkpointListLoading: state.categories.checkpointListLoading
    })
)
export default class CheckpointList extends Component {
    render() {
        const {
            checkpointList,
            checkpointListLoading,
        } = this.props;
        if (checkpointListLoading)
            return <Loading/>;
        return (
            <Card>
                <CardBody>
                    <h5>
                        Checkpoints <NewCheckpoint/>
                    </h5>
                    <ul className='list-unstyled'>
                        <DnDContext>
                            <DroppableContext droppableId={'checkpoint'}>
                                {
                                    checkpointList.map(
                                        (checkpoint, id) => <Checkpoint
                                            id={id}
                                            key={`checkpoint_${checkpoint.id}`}
                                            checkpoint={checkpoint}
                                        />
                                    )
                                }
                            </DroppableContext>
                        </DnDContext>
                    </ul>
                </CardBody>
            </Card>
        )
    }
}

